/* src/app/shared/components/mentor-document/mentor-document.component.scss */
.container {
  margin-left: 25px;
  margin-right: 30px;
  margin-bottom: 20px;
}
.title {
  text-align: left;
}
.action-button {
  border-radius: 22px;
  width: 124px;
}
.action-button mat-icon {
  width: 1.4rem;
}
.document-upload-row,
.existing-document-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.document-upload-row .filename,
.existing-document-row .filename {
  width: 250px;
  text-align: left;
  display: inline-block;
}
.document-upload-row .filename {
  margin: 0 25px 0 5px;
  overflow-x: hidden;
  padding: 9px 0 0 0;
}
.document-upload-row .no-document-message {
  color: #B62A39;
}
.upload-spinner {
  display: inline-block;
  border-radius: 22px;
  border: 1px solid #E0E0E0;
  width: 68px;
  padding: 0 15px;
  background-color: #E0E0E0;
  margin-right: 20px;
}
.upload-spinner .upload-spinner__content {
  margin: 7px 0;
}
.mat-icon {
  font-size: 22px;
}
.file-input {
  display: none;
}
a.customLink {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
  font-size: 14px;
  margin-right: 25px;
  margin-left: 5px;
  display: inline-block;
  padding: 9px 0 0 0;
}
/*# sourceMappingURL=mentor-document.component.css.map */
